"use strict";

var _toConsumableArray = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var hex_1 = require("../hex");

function anyToBuffer() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Buffer.alloc(0);
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = Object.assign({
    size: 0,
    autoStringDetect: false,
    defaults: Buffer.alloc(0)
  }, options);
  var result = options.defaults;

  switch (typeof data) {
    case 'number':
      {
        var _hex = data.toString(16);

        if (_hex.length % 2) {
          _hex = "0".concat(_hex);
        }

        result = Buffer.from(_hex, 'hex');
        break;
      }

    case 'string':
      var hex = data.startsWith('0x') || options.autoStringDetect ? hex_1.prepareHex(data, {
        evenLength: true
      }) : null;

      if (hex) {
        result = Buffer.from(hex, 'hex');
      } else {
        result = Buffer.from(data, 'utf8');
      }

      break;

    case 'boolean':
      result = Buffer.alloc(1, data ? 1 : 0);
      break;

    case 'object':
      if (Buffer.isBuffer(data)) {
        result = data;
      } else if (bn_js_1.default.isBN(data)) {
        var _hex2 = hex_1.prepareHex(data.toString(16), {
          evenLength: true
        });

        result = Buffer.from(_hex2, 'hex');
      } else if (data instanceof Uint8Array) {
        result = Buffer.from(_toConsumableArray(data));
      }

      break;
  }

  if (Buffer.isBuffer(result) && options.size > result.length) {
    result = Buffer.concat([Buffer.alloc(options.size - result.length, 0), result]);
  }

  return result;
}

exports.anyToBuffer = anyToBuffer;